export default (path, variations) => {
    return variations[path.replace(/\//g, "")] || variations.default;
};
